import React, { useEffect } from 'react';
import { Screen } from './onboardingScreenStyle';
import OnboardContent from './OnboardContent';

const OnboardingScreen = ({
  editStateYear,
  enableGtmTracking = false,
  onClose,
  ...dialogueProps
}) => {
  useEffect(() => {
    if (!enableGtmTracking) {
      return undefined;
    }

    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P3HWKVWQ');`;
    document.head.insertBefore(script, document.head.firstChild);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.setAttribute('data-dd-privacy', 'hidden');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-P3HWKVWQ';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    return () => {
      script.remove();
      noscript.remove();
    };
  }, [enableGtmTracking]);

  return (
    <Screen>
      <OnboardContent
        editStateYear={editStateYear}
        onClose={onClose}
        {...dialogueProps}
      />
    </Screen>
  );
};

export default OnboardingScreen;
